export class LoadBlockedCountires {
  static readonly type = '[BlockedCountires] Load Blocked Countires';
}
